import { DataBean } from "../DataBean";

export class RawMaterialRequestDocument extends DataBean {


    public async getRawMaterialRequestDocumentCatalog(idRawMaterialRequest:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialRequestDocumentCatalog_Number", [idRawMaterialRequest]);
    }
    
 
}